import React from 'react';
import { Container, NavButton, NotificationBadge } from './styles';

/**
 * TV-Optimized Bottom Navigation Bar
 * Fixed navigation with icon buttons
 */
export default function BottomNavBar({ items, activeIndex, onItemClick }) {
  if (!items || items.length === 0) return null;

  return (
    <Container>
      {items.map((item, index) => (
        <NavButton
          key={item.id || index}
          active={activeIndex === index}
          onClick={() => onItemClick?.(index)}
        >
          <i className={item.icon} aria-hidden='true'></i>
          {item.notification && <NotificationBadge />}
        </NavButton>
      ))}
    </Container>
  );
}
